import React, { useState, useEffect, useRef } from "react";
import BackButton from "globalComponents/BackButton";
import ChecklistItems from "./ChecklistItems";
import DoneChecklistItems from "./DoneChecklistItems";

import { connect } from "react-redux";
import {
  addChecklistItem,
  fetchChecklistItems,
} from "shared/checklists/redux/checklistSlice";
import store from "glassRedux/store";

export function ChecklistView(props) {
  const {
    setOpenChecklist,
    openChecklist,
    undoneIds,
    doneIds,
    loadingStatus,
    entities,
  } = props;

  const { itemId } = openChecklist;

  useEffect(() => {
    store.dispatch(fetchChecklistItems({ itemId }));
    window.addEventListener("beforeunload", onBeforeUnload);
    return function cleanup() {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (Object.keys(entities).length === 0 && loadingStatus === "idle") {
      store.dispatch(addChecklistItem({ index: 0 }));
    }
  }, [loadingStatus]);

  function onBeforeUnload(event) {
    event.preventDefault();
    event.returnValue = "saved";
  }

  function handleBackButtonClick() {
    setOpenChecklist((currOC) => {
      return { ...currOC, isOpen: false };
    });
  }

  return (
    <div className="backdrop">
      <div className="pane checklist-pane">
        <div className="pane-header checklist-pane-header">
          <BackButton handleBackButtonClick={handleBackButtonClick} />
          <span className="pane-title checklist-pane-title">Checklist</span>
        </div>
        <div className="checklist-items-container">
          <ChecklistItems
            {...{
              undoneIds,
              doneIds,
              entities,
              itemId,
            }}
          />
          <DoneChecklistItems {...{ doneIds, entities, undoneIds }} />
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    undoneIds: state.checklist.openChecklist.undoneIds,
    doneIds: state.checklist.openChecklist.doneIds,
    entities: state.checklist.openChecklist.entities,
    loadingStatus: state.checklist.status,
  };
}

export default connect(mapStateToProps)(ChecklistView);
